import { FrameName } from "../config";
import SettlementEmptyTerrainTileEntity from "./SettlementEmptyTerrainTileEntity";

class SettlementEmpty16TerrainTileEntity extends SettlementEmptyTerrainTileEntity {
	public static readonly frameName = FrameName.SETTLEMENT_EMPTY16;
}

export default SettlementEmpty16TerrainTileEntity;
